
export default function Heading() {

    return (
      <div>
        <h1 className='text-selected font-weight-bold' id='heading'>Isaak Krut</h1>
      </div>
    )
}